import press from './press';
export default press;
